import React from 'react';

interface CartConfirmStepBlockProps {
  title: string;
  active?: boolean;
}

export const CartConfirmStepBlock = ({
  title,
  active,
  ...props
}: CartConfirmStepBlockProps) => {
  return (
    <div
      {...props}
      className={`px-6 py-3 rounded-xl text-sm font-medium transition-colors ${
        active
          ? 'bg-red-600 text-white'
          : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
      }`}
    >
      {title}
    </div>
  );
};
